import React, { Component } from 'react';
import { Col, Card, CardBody, Row, CardTitle } from 'reactstrap';
import './style.scss'
import { connect } from 'react-redux';
import withAuth from '../../components/Services/WithAuth';
// import Table from "../../components/UI/Table/Table";
import * as caseCreateActions from '../../Analyst/Cases/Create/actions';
import { Preloading } from '../../components/UI/Preloader/action';
import {
    makeChartInfoForCaseOverviewResponse, makeChartInfoForCriticalCaseOverviewResponse,
    makeChartInfoForCorrespondentLoadOverviewResponse, getTableData
} from './helper';
import { getDataAdminDashboard } from './action';
import ViewGrid from './FirstChartTileDashboard/index';
import { setPageView } from '../../components/GoogleAnalytics/index';

class AdminDashboardComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false,
            showCasesLegend: true,
            showCriticalLegend: false,
            showCorrespondentsLegend: false,
            ShowError: false,
            dropdownText: "",
            adminDashBoardData: {},
            selectedChart: "caseOverviewResponse",
            tableDataList: [],
            correspondentLoad: []
        };
        this.props.getCounterpartyType();
        setPageView('/admin-dashboard', document.location.href)
    }
    
    componentDidMount = () => {
        this.props.preloading(true);
    }
    changeTableData(event) {
        event.preventDefault();
        let selected = event.target.getAttribute('indicator')
        if (event.target.getAttribute('indicator') === "in-progress") {
            this.setState({
                tableDataList: this.state.adminDashBoardData.caseOverviewResponse.pendingCasesMetadataList
            })
        } else if (event.target.getAttribute('indicator') === "completed") {
            this.setState({
                tableDataList: this.state.adminDashBoardData.caseOverviewResponse.completedCasesMetadataList
            })
        } else if (event.target.getAttribute('indicator') === "withdrawn") {
            this.setState({
                tableDataList: this.state.adminDashBoardData.caseOverviewResponse.withdrawnCasesMetadataList
            })
        }
        else if (event.target.getAttribute('indicator') === "expired") {
            this.setState({
                tableDataList: this.state.adminDashBoardData.criticalCaseOverviewResponse.expiredCaseList
            })
        }
        else if (event.target.getAttribute('indicator') === "critical") {
            this.setState({
                tableDataList: this.state.adminDashBoardData.criticalCaseOverviewResponse.criticalCaseList
            })
        }
        else if (event.target.getAttribute('indicator')) {

            this.setState(prevState => ({
                tableDataList: getTableData(this.state.correspondentLoad, selected)
            }));
        }
    }


    componentDidUpdate(prevProps) {
        if (this.props.counterpartyTypes !== prevProps.counterpartyTypes) {
            if (this.state.dropdownText === "") {
                this.props.getDataAdminDashboard(this.props.counterpartyTypes[0]);
            }
        }
        if (this.props.adminDashBoardData !== prevProps.adminDashBoardData) {
            let completedCasesMetadataList = Object.assign([], this.props.adminDashBoardData.data.caseOverviewResponse.completedCasesMetadataList);
            let pendingCasesMetadataList = Object.assign([], this.props.adminDashBoardData.data.caseOverviewResponse.pendingCasesMetadataList);
            let withdrawnCasesMetadataList = Object.assign([], this.props.adminDashBoardData.data.caseOverviewResponse.withdrawnCasesMetadataList);
            Array.prototype.push.apply(completedCasesMetadataList, pendingCasesMetadataList, withdrawnCasesMetadataList);
            this.setState({
                adminDashBoardData: this.props.adminDashBoardData.data,
                tableDataList: completedCasesMetadataList,
                ShowError: false,
                showCasesLegend: true,
                showCriticalLegend: false,
                showCorrespondentsLegend: false,
                selectedChart: 'caseOverviewResponse'
            }, () => {
                makeChartInfoForCaseOverviewResponse(this.state.adminDashBoardData.caseOverviewResponse);
                makeChartInfoForCriticalCaseOverviewResponse(this.state.adminDashBoardData.criticalCaseOverviewResponse);
                makeChartInfoForCorrespondentLoadOverviewResponse(this.state.adminDashBoardData.correspondentLoadOverviewResponse);
            });
            this.props.preloading(false);
        }
        else if (this.props.adminDashBoardDataError !== prevProps.adminDashBoardDataError) {
            this.setState({
                adminDashBoardData: {},
                ShowError: true
            });
            this.props.preloading(false);
        }
    }

    selectCounterPartyType = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.props.preloading(true);
        this.props.getDataAdminDashboard(event.currentTarget.selectedOptions[0].value)

    }

    onClickCounterPartyType = (event) => {
        event.preventDefault();
        event.stopPropagation();

    }

    selectCaseOverviewResponseTile = (event) => {
        event.preventDefault();
        let completedCasesMetadataList = Object.assign([], this.state.adminDashBoardData.caseOverviewResponse.completedCasesMetadataList);
        let pendingCasesMetadataList = Object.assign([], this.state.adminDashBoardData.caseOverviewResponse.pendingCasesMetadataList);
        let withdrawnCasesMetadataList = Object.assign([], this.state.adminDashBoardData.caseOverviewResponse.withdrawnCasesMetadataList);
        Array.prototype.push.apply(completedCasesMetadataList, pendingCasesMetadataList, withdrawnCasesMetadataList);
        this.setState({
            tableDataList: completedCasesMetadataList,
            ShowError: false,
            showCasesLegend: true,
            showCriticalLegend: false,
            showCorrespondentsLegend: false,
            selectedChart: 'caseOverviewResponse'
        })

    }

    selectCriticalCaseOverviewResponse = (event) => {
        event.preventDefault();
        let criticalCaseList = Object.assign([], this.state.adminDashBoardData.criticalCaseOverviewResponse.criticalCaseList);
        let expiredCaseList = Object.assign([], this.state.adminDashBoardData.criticalCaseOverviewResponse.expiredCaseList);
        Array.prototype.push.apply(criticalCaseList, expiredCaseList);
        this.setState({
            tableDataList: criticalCaseList,
            ShowError: false,
            showCasesLegend: false,
            showCriticalLegend: true,
            showCorrespondentsLegend: false,
            selectedChart: 'criticalCaseOverviewResponse'
        })

    }

    selectCorrespondentLoadOverviewResponse = (event) => {
        event.preventDefault();
        let tableData = getTableData(this.state.adminDashBoardData.correspondentLoadOverviewResponse)
        this.setState({
            tableDataList: tableData,
            correspondentLoad: tableData,
            ShowError: false,
            showCasesLegend: false,
            showCriticalLegend: false,
            showCorrespondentsLegend: true,
            selectedChart: 'correspondentLoadOverviewResponse'
        })
    }

    toggle = () => {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }
    render() {
        let dropdownList = this.props.counterpartyTypes.map(p => {
            return (
                <option key={p} className="px-3"  >{p}</option>
            );
        });
        if (this.state.ShowError === true) {
            return (
                <Col>
                    <div> Internal Server Error </div>
                </Col>
            )
        } else {
            return (
                <Col>
                    <Card>
                        <CardBody>
                            <Row className="mb-4">
                                <Col className="d-flex col-8">
                                    <Card className={this.state.selectedChart === 'caseOverviewResponse' ? "border radius-0 admin-dashboard-chart w-100 selected" : "border radius-0 admin-dashboard-chart w-100"} onClick={(event) => this.selectCaseOverviewResponseTile(event)}>
                                        <CardBody className="p-3">
                                            <CardTitle className="d-flex justify-content-between align-items-center">
                                                <span className="title">Cases</span>
                                                <select className="form-control d-flex justify-content-between align-items-center px-3 w-50" id="sel1" onClick={(event) => this.onClickCounterPartyType(event)} onChange={(event) => this.selectCounterPartyType(event)}>
                                                    {dropdownList}
                                                </select>
                                            </CardTitle>
                                            <div className="chart-container">
                                                <canvas id="caseOverviewResponse" className="caseOverviewResponse"></canvas>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col className="d-flex col-8">
                                    <Card className={this.state.selectedChart === 'criticalCaseOverviewResponse' ? "border radius-0 admin-dashboard-chart w-100 selected" : "border radius-0 admin-dashboard-chart w-100"} onClick={(event) => this.selectCriticalCaseOverviewResponse(event)}>
                                        <CardBody className="p-3">
                                            <CardTitle className="pt-2">
                                                <span className="title">Critical Cases</span>
                                            </CardTitle>
                                            <div className="chart-container">
                                                <canvas id="criticalCaseOverviewResponse" className="criticalCaseOverviewResponse"></canvas>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col className="d-flex col-8">
                                    <Card className={this.state.selectedChart === 'correspondentLoadOverviewResponse' ? "border radius-0 admin-dashboard-chart w-100 selected" : "border radius-0 admin-dashboard-chart w-100"} onClick={(event) => this.selectCorrespondentLoadOverviewResponse(event)}>
                                        <CardBody className="p-3">
                                            <CardTitle className="pt-2">
                                                <span className="title">Partner Load</span>
                                            </CardTitle>
                                            <div className="chart-container">
                                                <canvas id="correspondentLoadOverviewResponse" className="correspondentLoadOverviewResponse"></canvas>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col>
                                    <Card className="border">
                                        <CardBody className="d-flex" onClick={(event) => this.changeTableData(event)}>
                                            {this.state.showCasesLegend === true ? <div id='chartjsLegendCaseOverviewResponse' className="d-flex w-100"></div> : <div id='chartjsLegendCaseOverviewResponse' className="hidden"></div>}
                                            {this.state.showCriticalLegend === true ? <div id='chartjsLegendCriticalCaseOverviewResponse' className="d-flex w-100"></div> : <div id='chartjsLegendCriticalCaseOverviewResponse' className="hidden"></div>}
                                            {this.state.showCorrespondentsLegend === true ? <div id='chartjsLegendCorrespondentLoadOverviewResponse' className="d-flex w-100"></div> : <div id='chartjsLegendCorrespondentLoadOverviewResponse' className="hidden"></div>}
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div><ViewGrid {...this.props} data={this.state.tableDataList} /></div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            );
        }
    }
}
const mapStateToProps = (state) => ({
    adminDashBoardData: state.adminDashboard.adminDashBoardSuccessData,
    adminDashBoardDataError: state.adminDashboard.adminDashBoardFailureData,
    counterpartyTypes: state.createCase.dropdownData,
});

const mapDispatchToProps = (dispatch) => ({
    getDataAdminDashboard: (data) => { dispatch(getDataAdminDashboard(data)) },
    getCounterpartyType: () => { dispatch(caseCreateActions.getCounterpartyType()); },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(AdminDashboardComponent));
